(function (angular) {
    'use strict';

    angular.module('shared')
        /**
         * WARNING! `apiSpaces` is being injected in here but looks like it isn't used.
         *          you would be wrong!!!! LEAVE IT THERE  !!!!
         */
        .controller('HeaderCtrl', ['$scope', 'jwtService', '$state', '$uibModal', 'apiSpacePicker', 'localStorageService', 'coreDataService', 'sharedDataService', 'companyBillingService', 'moment', 'apiSpaces', 'myProfileService', 'permissionService', 'themeService', 'badgeService',
            function ($scope, jwtService, $state, $uibModal, apiSpacePicker, localStorageService, coreDataService, sharedDataService, companyBillingService, moment, apiSpaces, myProfileService, permissionService, themeService, badgeService) {

                $scope.jwt = jwtService;

                $scope.themeInfo = themeService.getThemeInfo();

                //profile

                function missingDetails(profile, accountId, userId) {
                    var modalInstance;
                    modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'shared/sidebar/userDetailsModal.html',
                        controller: 'userDetailsCtrl',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            details: {
                                email: profile.email,
                                firstName: profile.firstName == "." ? "" : profile.firstName,
                                lastName: profile.lastName == "." ? "" : profile.lastName,
                                accountId: accountId,
                                userId: userId
                            }
                        }
                    });


                    modalInstance.result.then(function (apiSpace) {
                    }, function (error) {

                    });
                }

                myProfileService.getMyProfile(jwtService.payload.accountId, jwtService.payload.userId).then(function (result) {

                    $scope.myProfileData = result;

                    if (!result.firstName || result.firstName == '.' || !result.lastName || result.lastName == '.') {
                        missingDetails(result, jwtService.payload.accountId, jwtService.payload.userId);
                    }
                }).catch(function (e) {
                    console.error(e);
                });

                $scope.$on('myProfile:changed', function (e, myProfile) {
                    if ($scope.myProfileData) {
                        $scope.myProfileData.avatarUrl = myProfile.avatarUrl;
                    }
                });

                $scope.contactPermission = permissionService.checkPermission("package:contact");
                $scope.hasChat = permissionService.checkPermission("chat:ro");

                $scope.$state = $state;


                //billing

                var subscriptionPermissions = {
                    toolkitpro: permissionService.checkPermission('package:toolkitpro'),
                    lite: permissionService.checkPermission('package:lite'),
                    toolkit: permissionService.checkPermission('package:toolkit'),
                }

                var packages = {
                    lite: {
                        label: 'Lite',
                        icon: 'assets/img/Lite_plain.png'
                    },
                    toolkit: {
                        label: 'Toolkit',
                        icon: 'assets/img/Toolkit_plain.png'
                    },
                    toolkitpro: {
                        label: 'Toolkit Pro',
                        icon: 'assets/img/Pro_plain.png'
                    }
                };

                for (var property in subscriptionPermissions) {
                    if (subscriptionPermissions.hasOwnProperty(property)) {
                        if (subscriptionPermissions[property]) {
                            $scope.subscription = packages[property];
                        }
                    }
                }


                $scope.sharedDataService = sharedDataService;
                var billingTimer;
                $scope.$watch('sharedDataService.getBilling()', function (newValue, oldValue) {
                    if (newValue && newValue.balance > 0) {
                        sharedDataService.setZeroBalanceWarning(false);
                    }
                    $scope.billingData = newValue;
                    if (typeof isTrial != 'undefined' && !isTrial && $scope.billingData && $scope.billingData.balance == 0 && !sharedDataService.getZeroBalanceWarning()) {
                        var zeroBalanceModalInstance = $uibModal.open({
                            animation: true,
                            templateUrl: 'shared/header/zeroBalanceModal.html',
                            controller: 'zeroBalanceModalCtrl'
                        });
                        zeroBalanceModalInstance.result.then(function () {
                            sharedDataService.setZeroBalanceWarning(true);
                        });
                    }
                }, true);
                var isTrial;
                companyBillingService.getCompanyDetails(jwtService.payload.accountId).then(function (response) {
                    $scope.isInvoiced = response.isInvoiced;
                    if (response.createdOn) {
                        $scope.now = moment();
                        $scope.accountCreated = response.createdOn ? moment(response.createdOn) : false;
                    }

                    sharedDataService.isInvoiced = $scope.isInvoiced;
                    if (response.address.timeZone) {
                        sharedDataService.timeZone = response.address.timeZone;
                    }
                    else {
                        sharedDataService.timeZone = moment.tz.guess();
                    }
                    isTrial = response.trialMode;
                    if (typeof $scope.isInvoiced != 'undefined' && !$scope.isInvoiced) {
                        coreDataService.getBilling($scope.jwt.payload.accountId);
                    }
                });

                $scope.navbarCollapsed = true;
                $scope.editingApiSpace = permissionService.checkPermission("apis:w");
                var cookieName = 'apiSpaces_' + jwtService.payload.userId;
                $scope.pickApiSpace = function (picked) {
                    apiSpacePicker.setPicked(picked);
                    localStorageService.setItem(cookieName, apiSpacePicker.getApiSpaces()[picked].id);
                };

                $scope.startPicker = function () {
                    $scope.apiSpaces = apiSpacePicker.getApiSpaces();
                    $scope.picked = apiSpacePicker.getPicked();

                    if (!$scope.apiSpaces.length) {
                        $scope.createNew(true);
                    }
                }

                $scope.$on('apiSpacesUpdate:content', function () {
                    $scope.apiSpaces = apiSpacePicker.getApiSpaces();
                });
                $scope.$on('apiSpacesUpdate:picked', function () {
                    $scope.picked = apiSpacePicker.getPicked();
                    var now = new Date();
                    var exp = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
                    localStorageService.setItem(cookieName, apiSpacePicker.getPickedApiSpace().id, { expires: exp });
                });
                $scope.$on('apiSpacesUpdate:deleted', function () {
                    if (!$scope.apiSpaces.length) {
                        $scope.createNew(true);
                    }
                });
                $scope.$on('apiSpace:add', function () {
                    $scope.createNew();
                });

                $scope.createNew = function (notClosable) {
                    var modalInstance;
                    if (notClosable) {
                        modalInstance = $uibModal.open({
                            animation: true,
                            templateUrl: 'components/platformConfiguration/apiSpaceDetails/templates/apiSpaceModal.html',
                            controller: 'apiSpaceModalCtrl',
                            backdrop: 'static',
                            keyboard: false,
                            resolve: {
                                isClosable: false
                            }
                        });
                    }
                    else {
                        modalInstance = $uibModal.open({
                            animation: true,
                            templateUrl: 'components/platformConfiguration/apiSpaceDetails/templates/apiSpaceModal.html',
                            controller: 'apiSpaceModalCtrl',
                            resolve: {
                                isClosable: true
                            }
                        });

                    }

                    modalInstance.result.then(function (apiSpace) {
                        if (notClosable) {
                            var now = new Date();
                            var exp = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
                            localStorageService.setItem(cookieName, apiSpace.id, { expires: exp });
                        }
                    }, function (error) {

                    });
                };

                $scope.signout = function () {
                    jwtService.clear();
                    sharedDataService.clearCache();
                    badgeService.setCount(0);
                    $state.go('login');
                };

                $scope.startPicker();



            }])
        .controller('apiSpaceModalCtrl', ['$scope', 'apiSpacesService', 'growlService', 'apiSpacePicker', '$uibModalInstance', 'isClosable',
            function ($scope, apiSpacesService, growlService, apiSpacePicker, $uibModalInstance, isClosable) {
                $scope.isClosable = isClosable;
                $scope.updateApiSpace = function () {

                    apiSpacesService.createApiSpace($scope.addData.name, $scope.addData.description)
                        .then(function (apiSpace) {
                            apiSpacePicker.addApiSpace(apiSpace);
                            if ($scope.isClosable) {
                                apiSpacePicker.setPicked(0);
                            }
                            $uibModalInstance.close(apiSpace);
                            growlService.success('Api Space created');
                        }).catch(function (error) {
                            growlService.danger("Api Space wasn't created due to: " + error.statusText);
                        });
                };
                $scope.endEditapiSpace = function () {
                    $uibModalInstance.dismiss('cancel');
                };


            }])
        .controller('confirmationModalCtrl', ['$scope', 'invoiceType', '$uibModalInstance',
            function ($scope, invoiceType, $uibModalInstance) {
                $scope.close = function () {
                    $uibModalInstance.close();
                };

                $scope.invoiceType = invoiceType;

            }])
        .controller('zeroBalanceModalCtrl', ['$scope', '$uibModalInstance',
            function ($scope, $uibModalInstance) {
                $scope.close = function () {
                    $uibModalInstance.close();
                };

            }])
        .controller('userDetailsCtrl', ['$scope', 'myProfileService', '$uibModalInstance', 'growlService', 'details',
            function ($scope, myProfileService, $uibModalInstance, growlService, details) {
                $scope.details = details;
                $scope.updateUserDetails = function () {

                    myProfileService.updateMyProfile($scope.details.accountId, $scope.details.userId, { firstName: $scope.details.firstName, lastName: $scope.details.lastName, email: $scope.details.email })
                        .then(function (result) {
                            $uibModalInstance.close();
                        }).catch(function (error) {
                            growlService.danger("Details wasn't set due to : " + error.statusText);
                        });
                };


            }]);

})(window.angular);
